export default "__VITE_ASSET__5a8dcf4c__"